import { CaseForms, UserRoleEnum } from "../../../helpers/enums";
interface Address {
  street: string;
  streetNumber: string;
  postalCode: string;
  city: string;
  province: string;
  region: string;
  country: string;
}

interface OnBoardingReq {
  name: string;
  surname: string;
  role: UserRoleEnum;
  email: string;
  pec: string;
  mobilePhoneNumber: string;
  landlinePhoneNumber: string;
  fax: string;
  fiscalCode: string;
  agreementProfiling: boolean;
  agreementMarketing: boolean;
  businessName: string;
  operatorCity: string;
  customerCity: string;
}

interface CondominiumPartitionReq {
  contractId: string;
  clientId: string;
  parcel: string;
  subaltern: string;
  housingUnit: string;
  residentNumber: string;
  name: string;
  surname: string;
  email: string;
  phone: string;
  address: string;
  privacy: boolean;
  divisionalMeters: boolean;
}

interface SimpleCase {
  category: CaseForms;
  type: string;
  subtype: string;
  note: string;
  serviceClaim: string;
  selfReading: string;
  businessName: string;
  checkMeter: boolean;
  integraClientCode: string;
  integraContractCode: string;
  landlinePhoneNumber: string;
  mobilePhoneNumber: string;
  email: string;
  pec: string;
  comunePuf: string;
  indirizzoPuf: string;
}

export class SimpleCaseModel implements SimpleCase {
  businessName = "";
  category = CaseForms.Empty;
  checkMeter = false;
  comunePuf = "";
  email = "";
  indirizzoPuf = "";
  integraClientCode = "";
  integraContractCode = "";
  landlinePhoneNumber = "";
  mobilePhoneNumber = "";
  note = "";
  pec = "";
  selfReading = "";
  serviceClaim = "";
  subtype = "";
  type = "";
  addressList = [];
  [key: string]: any;

  constructor(payload: Partial<SimpleCaseModel>) {
    console.log(payload);
    for (const key in payload) {
      if (this.hasOwnProperty(key)) {
        if (typeof this[key] === "boolean") {
          this[key] = Boolean(payload[key]);
          continue;
        }
        this[key] = payload[key];
      }
    }
  }
}

export class SpidRegisterModel implements OnBoardingReq {
  name = "";
  surname = "";
  role = UserRoleEnum.PRIVATE;
  email = "";
  pec = "";
  mobilePhoneNumber = "";
  landlinePhoneNumber = "";
  fax = "";
  fiscalCode = "";
  agreementMarketing = false;
  agreementProfiling = false;
  businessName = "";
  operatorCity = "";
  customerCity = "";
  [key: string]: any;

  constructor(payload: Partial<SpidRegisterModel>) {
    console.log(payload);
    for (const key in payload) {
      if (this.hasOwnProperty(key)) {
        if (typeof this[key] === "boolean") {
          this[key] = Boolean(payload[key]);
          continue;
        }
        this[key] = payload[key];
      }
    }
  }
}

export class CondominiumRegistryModel implements CondominiumPartitionReq {
  contractId = "";
  clientId = "";
  parcel = "";
  subaltern = "";
  housingUnit = "";
  residentNumber = "";
  name = "";
  surname = "";
  email = "";
  phone = "";
  address = "";
  privacy = true;
  divisionalMeters = true;
  [key: string]: any;

  constructor(payload: Partial<CondominiumRegistryModel>) {
    console.log(payload);
    for (const key in payload) {
      if (this.hasOwnProperty(key)) {
        if (typeof this[key] === "boolean") {
          this[key] = Boolean(payload[key]);
          continue;
        }
        this[key] = payload[key];
      }
    }
  }
}
